import React from 'react'
import { Popover, Tooltip } from 'antd'
import { IconInfo } from '@edulastic/icons'
import { themeColor } from '@edulastic/colors'
import { FlexContainer } from '@edulastic/common'
import { CustomWhiteBackgroundTooltip } from '../customTableTooltip'

export const ICON_INFO_OVERLAY = {
  WHITE: 'white',
  DARK: 'dark',
  POPOVER: 'popover',
}

export const GradeTooltipContent = ({ grades }) => (
  <div>
    The student is enrolled in classes with Class Grade {grades} in this term.
  </div>
)

export const StudentGradeTooltipContent = ({ grades }) => (
  <div>
    The student’s official enrolled grade for the school year is Grade {grades}.
  </div>
)

export const SchoolTooltipContent = ({ schools }) => (
  <div>
    The student is also enrolled in school <b>{schools}</b> in this term.
  </div>
)

const renderOverlay = ({
  title,
  trigger,
  variant,
  overlayClassName,
  placement,
}) => {
  switch (variant) {
    case ICON_INFO_OVERLAY.POPOVER:
      return (
        <Popover
          placement={placement}
          overlayClassName={overlayClassName || 'gi-summary-tile-info-popover'}
          content={
            <div className="content">
              <p>{title}</p>
            </div>
          }
        >
          {trigger}
        </Popover>
      )
    case ICON_INFO_OVERLAY.DARK:
      return (
        <Tooltip
          placement={placement}
          overlayClassName={overlayClassName || 'custom-dark-tooltip'}
          title={title}
        >
          {trigger}
        </Tooltip>
      )
    case ICON_INFO_OVERLAY.WHITE:
    default:
      return (
        <CustomWhiteBackgroundTooltip
          data={title}
          str={trigger}
          placement={placement}
        />
      )
  }
}

export const IconInfoWithTooltip = ({
  title,
  text,
  icon,
  variant = ICON_INFO_OVERLAY.WHITE,
  overlayClassName,
  placement = 'top',
}) => {
  const trigger = icon || <IconInfo fill={themeColor} />
  const overlay = renderOverlay({
    title,
    trigger,
    variant,
    overlayClassName,
    placement,
  })

  if (text === undefined) {
    return overlay
  }

  return (
    <FlexContainer justifyContent="center">
      {text}
      {overlay}
    </FlexContainer>
  )
}
